
export namespace StringEscape {
  export function unescape(value: string): string {
    return value.replace(/\\[bfntr'""`\\]/g, x => {
      if (x[1] == 'b') return '\b';
      if (x[1] == 'f') return '\f';
      if (x[1] == 'n') return '\n';
      if (x[1] == 't') return '\t';
      if (x[1] == 'r') return '\r';
      if (x[1] == '\'') return '\'';
      if (x[1] == '"') return '"';
      if (x[1] == '`') return '`';
      if (x[1] == '\\') return '\\';
      throw new Error(`Unrecognised escape sequence '${x}'`);
    });
  }
}
